const nxEntityUrlEmptyTypes = ['empty'];

export default {
  nxEntityUrlEmptyTypes,
};
